import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { brand } from '@iheart/shared';
import { GradientText, MotionButton } from '@iheart/ui';
import { useDocumentTitle } from '../lib/useDocumentTitle';
import { PageTransition } from '../components/PageTransition';

/**
 * 404 page shown when no route matches.
 * Offers a link back to the dashboard and a browser-back option.
 */
export function NotFoundRoute() {
  useDocumentTitle('Page not found');
  const navigate = useNavigate();

  return (
    <PageTransition className="flex min-h-screen flex-col items-center justify-center bg-white px-6">
      <div className="max-w-sm text-center">
        {/* Logo */}
        <img
          src="/logo.png"
          alt="iHeart CNTRL"
          className="mx-auto mb-6 size-14 object-contain"
        />

        {/* 404 badge */}
        <div
          className="mx-auto mb-5 flex size-20 items-center justify-center rounded-2xl text-white"
          style={{ backgroundImage: brand.gradient.primary }}
        >
          <span className="text-2xl font-bold tracking-tight">404</span>
        </div>

        <h1 className="text-xl font-semibold text-neutral-800">
          Page <GradientText>not found</GradientText>
        </h1>
        <p className="mt-2 text-sm text-neutral-500">
          The page you're looking for doesn't exist or has been moved. Let's get
          you back on track.
        </p>

        <div className="mt-6 flex items-center justify-center gap-3">
          <MotionButton size="sm" onClick={() => navigate('/')}>
            <Home className="mr-1.5 size-4" /> Go to dashboard
          </MotionButton>
          <MotionButton
            size="sm"
            variant="secondary"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="mr-1.5 size-4" /> Go back
          </MotionButton>
        </div>
      </div>
    </PageTransition>
  );
}
